import { render, staticRenderFns } from "./SynchronizeDOS.vue?vue&type=template&id=ecde0010&scoped=true"
import script from "./SynchronizeDOS.vue?vue&type=script&lang=js"
export * from "./SynchronizeDOS.vue?vue&type=script&lang=js"
import style0 from "./SynchronizeDOS.vue?vue&type=style&index=0&id=ecde0010&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecde0010",
  null
  
)

export default component.exports